export default "__VITE_PUBLIC_ASSET__cc9fc1f5__"